<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <span class="title_head">Search Sales</span>
          </div>
          <div class="card-body">
            <b-row>
              <b-col sm="3" v-if="is_admin === true">
                <b-form-group>
                  <label for="Company List"> Company List </label><br />
                  <model-list-select
                    :list="companylist"
                    option-value="company_id"
                    option-text="company_name"
                    v-model="selectcompany"
                    placeholder="Search Company Name"
                    @searchchange="searchcompany($event)"
                    @input="onSelectCompnay($event)"
                    style="
                      -webkit-text-fill-color: rgb(83, 108, 121) !important;
                      height: 30px !important;
                      border: 1px solid rgb(194, 207, 214);
                      min-height: 30px;
                      border-radius: 1px;
                      padding-top: 6px;
                    "
                    class="product-drop"
                  ></model-list-select>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group>
                  <label for="name"> From Date </label><br />
                  <date-picker
                    editable
                    lang="en"
                    v-model="todate"
                  ></date-picker>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group>
                  <label for="name"> To Date </label><br />
                  <date-picker
                    editable
                    lang="en"
                    v-model="fromdate"
                  ></date-picker>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group>
                  <label for="name">Sale Id </label>
                  <b-form-input
                    type="text"
                    v-model="productunit"
                    placeholder="Enter Sale Id"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group>
                  <!-- <span v-if="sale_view === true"> -->
                  <button
                    type="button"
                    v-if="sale_view === true"
                    style="margin-top: 24px; margin-left: 16%;"
                    class="btn btn-pill btn-primary serach_bttn"
                    @click="searchsales"
                  >
                    <i class="fa fa-search"></i>&nbsp;Search
                  </button>
                  <!-- </span>
                <span v-else>
                  <button type="button" style="margin-top: 24px; margin-left: 16%" class="btn btn-pill btn-primary serach_bttn">
                <i class="fa fa-search"></i>&nbsp;Search</button>
                </span> -->
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <div slot="header">
              <div class="row">
                <div class="col-sm-10">
                  <i style="color: #20a8d8;"></i> List Sales
                   <a href="#/sales/addsales" v-if="sale_rights === true"
                    ><button
                      type="button"
                      class="btn btn-sm btn-primary label_bttn"
                      @click.prevent="addsales()"
                    >
                      <i class="fa fa-plus"></i> Add Sales
                    </button></a>
                </div>
                <!-- <div class="col-sm-9"></div> -->
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                &nbsp;&nbsp;
                <div class="col-sm-1">
                  <button
                    id="MyDownload"
                    type="button"
                    v-if="sale_view === true"
                    class="btn btn-sm btn-primary label_bttn"
                    @click="exportData"
                  >
                    <i></i> Export Data
                  </button>
                </div>
              </div>
            </div>
            <!-- <span class="title_head">
              List Sales
              <span
                >&nbsp;&nbsp;
                <a href="#/sales/addsales" v-if="sale_rights === true"
                  ><button
                    type="button"
                    class="btn btn-sm btn-primary label_bttn"
                  >
                    <i class="fa fa-plus"></i> Add Sales
                  </button></a
                >
              </span>
               <span
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <button  id = 'MyDownload'
                   type="button"
                    v-if="sale_view === true"
                    class="btn btn-sm btn-primary label_bttn"
                    @click="exportData"
                  >
                    <i class="fa fa-plus"></i> Export Data
                    
                  </button>
              </span>
            </span> -->
          </div>
          <div class="card-body">
            <vue-good-table
              :columns="columns"
              :rows="rows"
              mode="remote"
              ref="my-table"
              :row-style-class="rowStyleClassFn"
              @on-page-change="onPageChange"
              @on-sort-change="onSortChange"
              @on-column-filter="onColumnFilter"
              @on-per-page-change="onPerPageChange"
              :totalRows="totalRecords"
              :pagination-options="{ enabled: true, perPage: 5 }"
              styleClass="vgt-table striped bordered table-sm condensed"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'action'">
                  <i
                    class="fa fa-eye"
                    @click="viewSale(props.row)"
                    style="color: #63c2de; font-size: 20px; cursor: pointer;"
                  ></i>
                  <span v-if="sale_rights === true">
                    <span v-if="props.row.sale_editable === true">
                      <i
                        class="fa fa-trash-o"
                        style="
                          color: #f44336;
                          font-size: 20px;
                          cursor: pointer;
                        "
                        v-on:click="removeSales(props.row)"
                      ></i>
                      <i
                        class="fa fa-pencil"
                        style="
                          color: #63c2de;
                          font-size: 20px;
                          cursor: pointer;
                        "
                        v-on:click="editSales(props.row)"
                      ></i>
                    </span>
                    <span v-else>
                      <i
                        class="fa fa-trash-o"
                        style="color: grey !important; font-size: 20px;"
                      ></i>
                      <i
                        class="fa fa-pencil"
                        style="color: grey !important; font-size: 20px;"
                      ></i>
                    </span>
                  </span>
                  <span v-else>
                    <i
                      class="fa fa-trash-o"
                      style="color: grey !important; font-size: 20px;"
                    ></i>
                    <i
                      class="fa fa-pencil"
                      style="color: grey !important; font-size: 20px;"
                    ></i>
                  </span>
                </span>

                <span v-if="props.column.field == 'adjust'">
                  <span v-if="sale_rights === true">
                    <i
                      v-if="props.row.salesadj === true"
                      class="fa fa-random fa-flip-horizontal"
                      style="color: #63c2de; font-size: 18px; cursor: pointer;"
                      v-on:click="saleadj(props.row)"
                    ></i>
                  </span>
                  <span v-else>
                    <i
                      v-if="props.row.salesadj === true"
                      class="fa fa-random fa-flip-horizontal"
                      style="color: grey !important; font-size: 18px;"
                    ></i>
                  </span>
                </span>
                <span v-if="props.column.field == 'generate'">
                  <button
                    type="submit"
                    style="width: 80px; border-radius: 20px;"
                    class="btn btn-primary"
                    v-show="is_admin !== true"
                    @click="generate_invoice(props.row)"
                  >
                    Invoice
                  </button>
                </span>
                <span v-if="props.column.field == 'gst_total'">
                  {{
                    (
                      parseFloat(props.row.cgst_amt) +
                      parseFloat(props.row.sgst_amt) +
                      parseFloat(props.row.igst_amt)
                    ).toFixed(2)
                  }}
                </span>
                <span v-else-if="props.column.field == 'return'">
                  <span v-if="sale_rights === true">
                    <i
                      class="fa fa-reply"
                      style="color: #63c2de; font-size: 18px; cursor: pointer;"
                      v-on:click="viewSale2(props.row)"
                    ></i>
                  </span>
                  <span v-else>
                    <i
                      class="fa fa-reply"
                      style="color: grey !important; font-size: 18px;"
                    ></i>
                  </span>
                </span>
                <span v-else-if="props.column.field == 'lastupdated_datetime'">
                  {{ newDate(props.row.lastupdated_datetime) }}
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      title="Sale Item Details "
      no-close-on-esc
      no-close-on-backdrop
      size="lg"
      hide-footer
      class="modal-warning"
      v-model="warningModal"
      @ok="warningModal = true"
      ok-variant="warning"
    >
      <b-collapse id="collapse1" visible>
        <vue-good-table
          :columns="columns1"
          :rows="rows1"
          mode="remote"
          ref="my-table1"
          @on-page-change="onPageChange1"
          @on-sort-change="onSortChange1"
          @on-column-filter="onColumnFilter1"
          @on-per-page-change="onPerPageChange1"
          :totalRows="totalRecords1"
          :pagination-options="{ enabled: true, perPage: 10 }"
          styleClass="vgt-table striped bordered table-sm condensed"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'tax_inclusive'">
              <div v-if="props.row.tax_inclusive == true">Inclusive</div>
              <div v-else>Exclusive</div>
            </span>
            <span v-else-if="props.column.field == 'gst_total'">
              {{
                (
                  parseFloat(props.row.cgst_amt) +
                  parseFloat(props.row.sgst_amt) +
                  parseFloat(props.row.igst_amt)
                ).toFixed(2)
              }}
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </b-collapse>
    </b-modal>

    <b-modal
      title="Select Sale Items To Return"
      no-close-on-esc
      no-close-on-backdrop
      size="lg"
      hide-footer
      class="modal-warning"
      v-model="warningModal1"
      @ok="warningModal1 = true"
      ok-variant="warning"
    >
      <b-collapse id="collapse2" visible>
        <vue-good-table
          :columns="columns2"
          :rows="rows2"
          :select-options="{
            enabled: true,
          }"
          mode="remote"
          ref="my-table2"
          @on-page-change="onPageChange2"
          @on-sort-change="onSortChange2"
          @on-column-filter="onColumnFilter2"
          @on-per-page-change="onPerPageChange2"
          :totalRows="totalRecords2"
          :pagination-options="{ enabled: true, perPage: 10 }"
          styleClass="vgt-table striped bordered table-sm condensed"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'tax_inclusive'">
              <div v-if="props.row.tax_inclusive == true">Inclusive</div>
              <div v-else>Exclusive</div>
            </span>
            <span v-else-if="props.column.field == 'gst_total'">
              {{
                (
                  parseFloat(props.row.cgst_amt) +
                  parseFloat(props.row.sgst_amt) +
                  parseFloat(props.row.igst_amt)
                ).toFixed(2)
              }}
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </b-collapse>
      <button
        v-if="sale_rights === true"
        type="button"
        class="btn btn-sm btn-primary label_bttn"
        @click="returnitems"
      >
        Proceed
      </button>
    </b-modal>

    <b-modal
      title="Sale Adjustment"
      no-close-on-esc
      no-close-on-backdrop
      size="lg"
      hide-footer
      class="modal-warning"
      v-model="saleadjModal"
      @ok="saleadjModal = true"
      ok-variant="saleadj"
    >
      <label for="name">Sale ID : {{ sales_adj_salesid }}</label>
      <b-collapse id="collapse2" visible>
        <vue-good-table
          :columns="columns_adj"
          :rows="rows_adj"
          mode="remote"
          ref="my-table_adj"
          @on-page-change="onPageChange_adj"
          @on-sort-change="onSortChange_adj"
          @on-column-filter="onColumnFilter_adj"
          @on-per-page-change="onPerPageChange_adj"
          :totalRows="totalRecords_adj"
          :pagination-options="{ enabled: false, perPage: 10 }"
          styleClass="vgt-table striped bordered table-sm condensed"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'action'">
              <span v-if="sale_rights === true">
                <i
                  v-if="props.row.inv_qty > 0"
                  class="fa fa-random fa-flip-horizontal"
                  style="color: #63c2de; font-size: 18px; cursor: pointer;"
                  v-on:click="adjust(props.row)"
                ></i>
                <!--
                  <a v-if="props.row.inv_qty > 0" @click="adjust(props.row)" style="color:#63c2de;font-size: 20px; cursor: pointer;">Adjust</a>-->
              </span>
              <span v-else>
                <i
                  class="fa fa-random fa-flip-horizontal"
                  style="color: grey !important; font-size: 18px;"
                ></i>
                <!--<a style="color:grey !important;font-size: 20px;">Adjust</a>-->
              </span>
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </b-collapse>
    </b-modal>
    <b-modal
      title="Plan Limit Reached"
      size="sm"
      class="modal-warning"
      ok-only 
      v-model="plan_modal"
    >
    <b-row>
      <b-col sm="2">
          <i class="fa fa-exclamation" style="font-size:40px;color:red"></i>
        </b-col>
        <b-col sm="10">
          <b-row>
          <b>You have hit the plan limit.</b>
          </b-row>
          <b-row>
            You have reached the limit of adding Sales. Please upgrade your plan to add more Sales.
          </b-row>
        </b-col>
      </b-row>
    </b-modal>
    <Spinner v-if="loading"></Spinner>
  </div>
</template>

<script>
import Spinner from "../../spinner.vue";
import { VueEditor } from "vue2-editor";
import DatePicker from "vue2-datepicker";
export default {
  components: {
    "date-picker": DatePicker,
    Spinner,
  },
  data() {
    return {
      companylist: [],
      plan_modal:false,
      selectcompany: null,
      slfirst: false,
      shpfirst: false,
      todate: "",
      fromdate: "",
      productunit: "",
      productqty: "",
      rows1: [],
      rows2: [],
      rows: [],
      rows_adj: [],
      message: "",
      sales_adj_salesid: null,
      warningModal: false,
      warningModal1: false,
      saleadjModal: false,
      largeModal: false,
      loading: false,
      srchSales: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5,
      },
      totalRecords1: 0,
      serverParams1: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 10,
      },
      totalRecords2: 0,
      serverParams2: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 10,
      },
      totalRecords_adj: 0,
      serverParams_adj: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 10,
      },
      temprow: null,
      // pg_view : false,
      // pg_rights : false,
      columns1: [
        {
          label: "Product Name",
          field: "product_name",
          width: "20% !important",
        },
        {
          label: "Variant",
          field: "variant_id",
          width: "10% !important",
        },
        {
          label: "Qty",
          field: "sale_qty",
          width: "10% !important",
        },
        {
          label: "Price",
          field: "product_unit_cost",
          width: "10% !important",
          formatFn: this.formatFn,
        },
        {
          label: "Sub Total",
          field: "sub_total",
          width: "10% !important",
          formatFn: this.formatFn,
        },
        {
          label: "Tax",
          field: "tax_inclusive",
          width: "10% !important",
        },
        {
          label: "GST%",
          field: "gst_total",
          width: "15% !important",
        },
        {
          label: "Amount",
          field: "amt_to_pay",
          width: "15% !important",
          formatFn: this.formatFn,
        },
      ],
      columns2: [
        {
          label: "Product Name",
          field: "product_name",
          width: "20% !important",
        },
        {
          label: "Variant",
          field: "variant_id",
          width: "10% !important",
        },
        {
          label: "Qty",
          field: "sale_qty",
          width: "10% !important",
        },
        {
          label: "Price",
          field: "product_unit_cost",
          width: "10% !important",
          formatFn: this.formatFn,
        },
        {
          label: "Sub Total",
          field: "sub_total",
          width: "10% !important",
          formatFn: this.formatFn,
        },
        {
          label: "Tax",
          field: "tax_inclusive",
          width: "10% !important",
        },
        {
          label: "GST%",
          field: "gst_total",
          width: "15% !important",
        },
        {
          label: "Amount",
          field: "amt_to_pay",
          width: "15% !important",
          formatFn: this.formatFn,
        },
        {
          label: "Return Qty",
          field: "return_qty",
          width: "15% !important",
        },
      ],
      columns_adj: [
        {
          label: "Product",
          field: "product_name",
          width: "5% !important",
        },
        {
          label: "Variant",
          field: "variant_id",
          width: "20% !important",
        },
        {
          label: "Sales Qty",
          field: "sale_qty",
          width: "20% !important",
        },
        {
          label: "Adjust Qty",
          field: "adjusted_qty",
          width: "10% !important",
        },
        {
          label: "Available Qty",
          field: "inv_qty",
          width: "10% !important",
        },
        {
          label: "Action",
          field: "action",
          width: "15% !important",
        },
      ],
    };
  },
  computed: {
    companyTaxType() {
      var companyId = localStorage.getItem('companyId') || ''
      return (this.$config && this.$config.companyTaxLogic && this.$config.companyTaxLogic[companyId]) || 'IN'
    },
    columns() {
      return [
        { label: "Sales Id", field: "sales_id", width: "7% !important", thClass: "text-center" },
        { label: "Customer", field: "cust_cmp_name", width: "13% !important", thClass: "text-center" },
        { label: "Shop", field: "est_shop_name", width: "13% !important", thClass: "text-center" },
        { label: this.companyTaxType === 'US' ? "Tax Amount" : "GST Amount", field: "gst_total", width: "12% !important", thClass: "text-center" },
        { label: "Total Amount", field: "total_amt_pay", width: "10% !important", formatFn: this.formatFn, thClass: "text-center" },
        { label: "Sale Entry Date", field: "sale_entry_date", type: "date", dateInputFormat: "YYYY-MM-DDThh:mm:ss", dateOutputFormat: "Do MMM YYYY", tdClass: "text-left", width: "12% !important", thClass: "text-center" },
        { label: "Action", field: "action", width: "10% !important", thClass: "text-center", tdClass: "text-center" },
        { label: "Return", field: "return", width: "5% !important", tdClass: "text-center", thClass: "text-center" },
        { label: "Sale Adjust", field: "adjust", width: "8% !important", tdClass: "text-center", thClass: "text-center" },
        { label: "Generate", field: "generate", width: "10% !important", tdClass: "text-center", thClass: "text-center" },
      ]
    },
    sale_view: function () {
      if (this.$store.getters.get_is_admin !== true) {
        if (this.$store.getters.get_sale_view === true) {
          this.sales("comp");
          this.shopuser("comp");
          return true;
        } else {
          return false;
        }
      }
    },
    sale_rights: function () {
      return this.$store.getters.get_sale_rights;
    },
    is_admin: function () {
      return this.$store.getters.get_is_admin;
    },
  },

  methods: {
    rowStyleClassFn(row) {
      return row.salesadj == true
        ? "background-color:green"
        : "background-color:red";
    },
    
    addsales() {
      var _this = this;
      this.loading = true;
      this.$router.push({ name: "Add Sales" });
      // this.$http
      //   .get("/api/saledetails/chk_plan_count")
      //   .then(function (response) {
      //     // console.log(response.data.message)
      //     _this.loading = false;
      //     if ("message" in response.data) {
      //       if (response.data.message === true) {
      //         _this.plan_modal = true;
      //       } else {
      //         _this.plan_modal = false;
      //         _this.$router.push({ name: "Add Sales" });
      //       }
      //     } else {
      //       console.log("something went wrong");
      //     }
      //   })
      //   .catch(function (error) {
      //     console.log(error);
      //   });
    },
    
    searchcompany(searchText) {
      var _this = this;
      this.$http
        .get(
          "/api/companies?filter[where][company_name][ilike]=%" +
            searchText +
            "%"
        )
        .then(function (response) {
          // console.log(response)
          _this.companylist = response.data;
        })
        .catch(function (error) {});
    },

    onSelectCompnay(selected_company) {
      this.loadItems();
    },

    generate_invoice(row) {
      var route_query = { sid: row.sales_id, cid: row.customer_id };
      // if (this.selectcompany !== null) {
      //   route_query = { sid: row.sales_id, cid: row.customer_id, cmpid:this.selectcompany.company_id,
      //    regcity: this.selectcompany.regcity_code }
      // }
      // else{
      //   route_query = { sid: row.sales_id, cid: row.customer_id }
      // }
      let routeData = this.$router.resolve({
        name: "Sale Invoice Pdf",
        query: route_query,
      });
      window.open(routeData.href, "_blank");
    },
    editSales(row) {
      var _this = this;
      this.loading = true;
      this.$http
        .post(
          "/api/salesadjustments/getPurchaseAdj?saleId=" +
            row.sales_id +
            "&shp_id=" +
            row.est_shop_id
        )
        .then(function (response) {
          if (response.data.data !== null) {
            setTimeout(function () {
              _this.loading = false;
            }, 2000);
            alert(
              "Sales id - " +
                row.sales_id +
                " belongs to Sale Adjustment which is been adjusted, so cannot be edited"
            );
          } else {
            setTimeout(function () {
              _this.loading = false;
            }, 2000);
            _this.$router.props = [row.sales_id];
            localStorage.setItem("sales_id", JSON.stringify(row.sales_id));
            _this.$router.push("/sales/editsales");
          }
        })
        .catch(function (error) {});
    },
    removeSales(row) {
      var r = confirm("Are you sure you want to delete?");
      if (r == true) {
        var _this = this;
        this.loading = true;
        this.$http
          .delete("api/sales/removeSale?id=" + row.sales_id)
          .then(function (response) {
            if (response.status == 200) {
              if (response.data.res === "Successful") {
                _this.loading = false;
                _this.sales();
              } else {
                alert(response.data.res);
                _this.loading = false;
              }
            }
          })
          .catch(function (error) {});
      }
    },

    adjust(row) {
      var r = confirm("Are you sure you want to Adjust Sale from inventory?");
      if (r == true) {
        var _this = this;
        this.loading = true;
        // var data = {}
        // data['sales_id'] = _this.sales_adj_salesid
        // data['sale_itemno'] = row.sale_itemno
        // data['product'] = row.product_id
        // data['variant'] = row.variant_id
        // data['est_shop_id'] = row.est_shop_id
        // data['adj_qty']= row.adjusted_qty
        // data['avaqty'] = row.inv_qty

        this.$http
          .get(
            "/api/salesadjustments/adjustSale?filter[where][saleadj_id]=" +
              row.saleadjustment_id
          )
          .then(function (response) {
            if (response.status == 200) {
              // console.log(response.data)
              if (response.data.res == "success") {
                _this.saleadj(_this.temprow);
                _this.loading = false;
                _this.message = "Sales Adjusted Successfully";
                setTimeout(function () {
                  _this.message = "";
                }, 2000);
              } else {
                _this.saleadj(_this.temprow);
                _this.loading = false;
                _this.message = response.data.res;
                setTimeout(function () {
                  _this.message = "";
                }, 2000);
              }
            } else {
              // console.log("Didm't got response")
              _this.loading = false;
              _this.message =
                "Some error occurred while adjust. Kindly contact to admin";
              setTimeout(function () {
                _this.message = "";
              }, 2000);
            }
            setTimeout(function () {
              _this.saleadj(_this.temprow);
              _this.loading = false;
            }, 1000);
            _this.message = "Sales Adjusted Successfully";
            setTimeout(function () {
              _this.message = "";
            }, 2000);
          });
      }
    },

    saleadj(row) {
      this.rows_adj.length = 0;
      // let filteParam = {};
      // filteParam.page = this.serverParams_adj.page;
      // filteParam.perPage = this.serverParams_adj.perPage;
      // filteParam.sort = this.serverParams_adj.sort;
      this.saleadjModal = true;
      this.sales_adj_salesid = row.sales_id;
      var _this = this;
      this.temprow = row;
      // var data =[]
      // console.log('saleadj')
      this.$http
        .get(
          "/api/salesadjustments/getSaleAdj?filter[where][sales_id]=" +
            row.sales_id +
            "&filter[where][est_shop_id]=" +
            row.est_shop_id
        )
        .then(function (response) {
          // console.log(response)
          if (response.status == 200) {
            if (response.data.data !== undefined) {
              if (response.data.data.length > 0) {
                // console.log(response)
                _this.totalRecords_adj = response.data.data["0"]["count"];
                _this.rows_adj = response.data.data;
                // console.log(_this.rows_adj)
              } else {
                _this.saleadjModal = false;
              }
            } else {
              console.log("data undefined");
            }
            // _this.totalRecords1 = response.data.length
            //  _this.rows1=response.data;
            //  console.log(_this.rows1)
          } else {
            console.log("Didn't got response");
          }
        });
    },

    returnitems() {
      var sales_id = this.$refs["my-table2"].selectedRows[0]["sales_id"];
      var est_shop_id = this.$refs["my-table2"].selectedRows[0]["est_shop_id"];

      if (this.$refs["my-table2"].selectedRows.length > 0) {
        if ("sales_return_id" in this.$refs["my-table2"].selectedRows[0]) {
          var item_seqs = {};
          for (
            var i = 0;
            i < this.$refs["my-table2"].selectedRows.length;
            i++
          ) {
            item_seqs[
              this.$refs["my-table2"].selectedRows[i].item_seq
            ] = this.$refs["my-table2"].selectedRows[i].sale_qty;
          }
          // console.log({'saleId': sales_id, 'shopId': est_shop_id, 'itemSeqs': item_seqs, 'salesReturnId': this.$refs['my-table2'].selectedRows[0]['sales_return_id']})
          this.$router.push({
            name: "Edit Sales Return",
            params: {
              saleId: sales_id,
              shopId: est_shop_id,
              itemSeqs: JSON.stringify(item_seqs),
              saleReturnId: this.$refs["my-table2"].selectedRows[0][
                "sales_return_id"
              ],
            },
          });
        } else {
          var item_seqs = [];
          for (
            var i = 0;
            i < this.$refs["my-table2"].selectedRows.length;
            i++
          ) {
            item_seqs.push(this.$refs["my-table2"].selectedRows[i].item_seq);
          }
          this.$router.push({
            name: "Add Sales Return",
            params: {
              saleId: sales_id,
              shopId: est_shop_id,
              itemSeqs: item_seqs,
            },
          });
        }
      } else {
        return;
      }
    },
    newDate(date1) {
      var dt1 = new Date(date1);
      var year = dt1.getFullYear();
      var month = dt1.getMonth() + 1;
      var day = dt1.getDate();
      var dt2 = year + "-" + month + "-" + day;
      return dt2;
    },

    shopuser(val) {
      if (val === "comp") {
        if (this.shpfirst === false) {
          this.shpfirst = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http
        .get("/api/shopusers")
        .then(function (response) {})
        .catch(function (error) {
          if (error.response.status === 401) {
            localStorage.clear();
            _this.$store.commit("SET_AUTH_USER", null);
            _this.$router.push("/");
          }
          if (
            error.response.data.error.message ===
            "Cannot read property 'cmpname' of null"
          ) {
            localStorage.clear();
            _this.$store.commit("SET_AUTH_USER", null);
            _this.$router.push("/");
          }
        });
    },

    formatFn(value) {
      return parseFloat(value).toFixed(2);
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems();
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.loadItems();
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        },
        page: 1,
      });
      this.loadItems();
    },

    onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },

    updateParams1(newProps, row) {
      this.serverParams1 = Object.assign({}, this.serverParams1, newProps);
    },

    onPageChange1(params, row) {
      this.updateParams1({ page: params.currentPage });
      this.viewSale(this.temprow);
    },

    onPerPageChange1(params, row) {
      this.updateParams1({ perPage: params.currentPerPage, page: 1 });
      this.viewSale(this.temprow);
    },

    onSortChange1(params, row) {
      this.updateParams1({
        sort: {
          type: params.sortType,
          field: this.columns1[params.columnIndex].field,
        },
        page: 1,
      });
      this.viewSale(this.temprow);
    },

    onColumnFilter1(params, row) {
      this.updateParams1(params);
      this.viewSale(this.temprow);
    },

    updateParams2(newProps, row) {
      this.serverParams2 = Object.assign({}, this.serverParams2, newProps);
    },

    onPageChange2(params, row) {
      this.updateParams2({ page: params.currentPage });
      this.viewSale(this.temprow);
    },

    onPerPageChange2(params, row) {
      this.updateParams2({ perPage: params.currentPerPage, page: 1 });
      this.viewSale(this.temprow);
    },

    onSortChange2(params, row) {
      this.updateParams2({
        sort: {
          type: params.sortType,
          field: this.columns2[params.columnIndex].field,
        },
        page: 1,
      });
      this.viewSale(this.temprow);
    },

    onColumnFilter2(params, row) {
      this.updateParams2(params);
      this.viewSale(this.temprow);
    },

    updateParamsAdj(newProps) {
      this.serverParams_adj = Object.assign(
        {},
        this.serverParams_adj,
        newProps
      );
    },

    onPageChange_adj(params) {
      this.updateParamsAdj({ page: params.currentPage });
      this.saleadj(this.temprow);
    },

    onPerPageChange_adj(params) {
      this.updateParamsAdj({ perPage: params.currentPerPage, page: 1 });
      this.saleadj(this.temprow);
    },

    onSortChange_adj(params) {
      this.updateParamsAdj({
        sort: {
          type: params.sortType,
          field: this.columns_adj[params.columnIndex].field,
        },
        page: 1,
      });
      this.saleadj(this.temprow);
    },

    onColumnFilter_adj(params) {
      this.updateParamsAdj(params);
      this.saleadj(this.temprow);
    },

    // load items is what brings back the rows from server
    loadItems() {
      // console.log('loaditems')
      let filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;

      var _this = this;
      var data = [];
      this.rows = [];
      var unit = this.productunit;
      var qty = this.productqty;
      var num = /^[0-9]{1}$/;
      var dateto = new Date(this.todate);
      var year = dateto.getFullYear();
      var month = dateto.getMonth() + 1;
      var day = dateto.getDate();
      this.loading = true;
      if (num.test(month) == true) {
        var month = "0" + month;
      } else {
        var month = month;
      }

      if (num.test(day) == true) {
        var day = "0" + day;
      } else {
        var day = day;
      }
      var datefrom = new Date(this.fromdate);
      var year1 = datefrom.getFullYear();
      var month1 = datefrom.getMonth() + 1;
      var daycon = datefrom.getDate();
      if (num.test(month1) == true) {
        var month1 = "0" + month1;
      } else {
        var month1 = month1;
      }
      if (num.test(daycon) == true) {
        var day1 = "0" + daycon;
      } else {
        var day1 = daycon;
      }

      var todate1 = year + "-" + month + "-" + day;
      var fromdate1 = year1 + "-" + month1 + "-" + day1;
      if (this.todate != "" && this.fromdate != "") {
        data =
          data +
          " &filter[where][lastupdated_datetime][between][0]=" +
          todate1 +
          " &filter[where][lastupdated_datetime][between][1]=" +
          fromdate1;
      } else {
        if (this.todate != "") {
          data = data + "&filter[where][lastupdated_datetime]=" + todate1;
        }
        if (this.fromdate != "") {
          data = data + "&filter[where][lastupdated_datetime]=" + fromdate1;
        }
      }

      if (this.productunit != "") {
        data = data + "&filter[where][sales_id]=" + unit;
      }

      if (this.selectcompany !== null) {
        data =
          data +
          "&filter[where][company_id]=" +
          this.selectcompany.company_id +
          "&filter[where][user_id]=" +
          this.selectcompany.cmp_email +
          "&filter[where][regcity]=" +
          this.selectcompany.regcity_code;
      }
      // console.log(data);
      this.$http
        .get(
          "/api/saledetails/getSales?params=" +
            JSON.stringify(filteParam) +
            data
        )
        .then(function (response) {
          // console.log(response);
          _this.totalRecords = response.data[0].totalRecords;
          response.data.shift();
          if (response.data != undefined) _this.rows = response.data;
          _this.loading = false;
        })
        .catch(function (er) {
          console.log(er);
          _this.loading = false;
        });
    },

    sales(val) {
      if (val === "comp") {
        if (this.slfirst === false) {
          this.slfirst = true;
        } else {
          return;
        }
      }
      this.loadItems();
    },
    viewSale(row) {
      this.rows1.length = 0;
      let filteParam = {};
      filteParam.page = this.serverParams1.page;
      filteParam.perPage = this.serverParams1.perPage;
      filteParam.sort = this.serverParams1.sort;
      this.warningModal = true;
      var _this = this;
      this.temprow = row;
      // var data =[]
      var data = "&filter[where][sales_id]=" + row.sales_id;
      if (this.selectcompany !== null) {
        data =
          data +
          "&filter[where][company_id]=" +
          this.selectcompany.company_id +
          "&filter[where][regcity]=" +
          this.selectcompany.regcity_code;
      }
      this.$http
        .get(
          "/api/saledetails/searchdb?params=" +
            JSON.stringify(filteParam) +
            data
        )
        .then(function (response) {
          if (response.data != undefined) {
            _this.totalRecords1 = response.data[0].totalRecords;
            response.data.shift();
            _this.rows1 = response.data;
            // console.log(_this.rows1)
          }
        });
    },

    viewSale2(row) {
      this.rows2.length = 0;
      let filteParam = {};
      filteParam.page = this.serverParams2.page;
      filteParam.perPage = this.serverParams2.perPage;
      filteParam.sort = this.serverParams2.sort;
      this.warningModal1 = true;
      var _this = this;
      this.temprow = row;
      var data = [];
      var data =
        data +
        "&filter[where][sales_id]=" +
        row.sales_id +
        "&filter[where][chk_return]=true";

      this.$http
        .get(
          "/api/saledetails/searchdb?params=" +
            JSON.stringify(filteParam) +
            data
        )
        .then(function (response) {
          if (response.data != undefined) {
            // _this.rows2=response.data.sale_dt;
            // console.log(response.data)
            if ("sale_rt_dt" in response.data) {
              _this.totalRecords2 = response.data.sale_dt.length;
              var sale_return_id =
                response.data.sale_rt_dt[0]["sales_return_id"];
              var obj_rtitemseq = {};
              // var select_row = []
              var sale_data = response.data.sale_dt;
              var sale_rt_dt = response.data.sale_rt_dt;
              for (var i = 0; i < sale_rt_dt.length; i++) {
                obj_rtitemseq[parseInt(sale_rt_dt[i].item_seq)] = parseInt(
                  sale_rt_dt[i].return_qty
                );
              }
              for (var j = 0; j < sale_data.length; j++) {
                if (parseInt(sale_data[j].item_seq) in obj_rtitemseq) {
                  sale_data[j]["return_qty"] =
                    obj_rtitemseq[sale_data[j].item_seq];
                  sale_data[j]["sales_return_id"] = sale_return_id;
                } else {
                  sale_data[j]["return_qty"] = 0;
                  sale_data[j]["sales_return_id"] = sale_return_id;
                }
              }
              _this.rows2 = sale_data;
              for (var k = 0; k < _this.rows2.length; k++) {
                if (parseInt(_this.rows2[k].item_seq) in obj_rtitemseq) {
                  _this.$set(_this.rows2[k], "vgtSelected", true);
                }
              }
            } else {
              _this.rows2 = response.data;
              _this.totalRecords2 = response.data.length;
            }
            // console.log(_this.responseows1)
          }
        });
    },
    //Nishith Changes For Excel Report
    exportData() {
      // alert('data')
      let filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;

      var _this = this;
      var unit = this.productunit;
      var qty = this.productqty;
      var num = /^[0-9]{1}$/;
      var data = [];
      var dateto = new Date(this.todate);
      var year = dateto.getFullYear();
      var month = dateto.getMonth() + 1;
      var day = dateto.getDate();
      this.loading = true;

      if (num.test(month) == true) {
        var month = "0" + month;
      } else {
        var month = month;
      }

      if (num.test(day) == true) {
        var day = "0" + day;
      } else {
        var day = day;
      }
      var datefrom = new Date(this.fromdate);
      var year1 = datefrom.getFullYear();
      var month1 = datefrom.getMonth() + 1;
      var daycon = datefrom.getDate();
      if (num.test(month1) == true) {
        var month1 = "0" + month1;
      } else {
        var month1 = month1;
      }
      if (num.test(daycon) == true) {
        var day1 = "0" + daycon;
      } else {
        var day1 = daycon;
      }

      var todate1 = year + "-" + month + "-" + day;
      var fromdate1 = year1 + "-" + month1 + "-" + day1;
      if (this.todate != "" && this.fromdate != "") {
        data =
          data +
          " &filter[where][lastupdated_datetime][between][0]=" +
          todate1 +
          " &filter[where][lastupdated_datetime][between][1]=" +
          fromdate1;
      } else {
        if (this.todate != "") {
          data = data + "&filter[where][lastupdated_datetime]=" + todate1;
        }
        if (this.fromdate != "") {
          data = data + "&filter[where][lastupdated_datetime]=" + fromdate1;
        }
      }

      if (this.productunit != "") {
        data = data + "&filter[where][sales_id]=" + unit;
      }

      if (this.selectcompany !== null) {
        data =
          data +
          "&filter[where][company_id]=" +
          this.selectcompany.company_id +
          "&filter[where][user_id]=" +
          this.selectcompany.cmp_email +
          "&filter[where][regcity]=" +
          this.selectcompany.regcity_code;
      }
      //  console.log(data.length)

      this.loading = true;
      if(this.rows.length > 0) {

      
      this.$http
        .get(
          "/api/saledetails/getSalesExport?params=" +
            JSON.stringify(filteParam) +
            data
        )
        .then(function (response) {
          //  console.log(response)

          //  alert('isslke paas')
          var access_token = localStorage.getItem("authUser");
          //  console.log(response.data)x

          var url1 =
            _this.baseURL2 +
            "/api/containers/csv/download/" +
            response.data +
            "?access_token=" +
            access_token;
          // console.log('url  '  + url1)
          // var url1 = '/api/containers/csv/download/1593025721009.csv';
          _this
            .$http({
              url: url1,
              method: "GET",
              responseType: "blob",
            })
            .then((res) => {
              _this.loading = false;
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement("a");
              link.setAttribute("download", response.data);
              link.href = url1;
              document.body.appendChild(link);
              link.click();
            })
            .catch(function (er) {
              console.log(er);
              _this.loading = false;
            });

          //  _this.loading = false;
          ///End OF Exce Downlod Method...
        });
      } else {
          _this.loading = false;
          alert('No Data Found')
      }
    },

    searchsales() {
      // console.log('searchsales')
      this.updateParams({
        sort: {
          type: "",
          field: "",
        },
        page: 1,
      });
      this.$refs["my-table"].reset();
      this.loadItems();
    },

    // return_sale(row){
    //   console.log('return sale')
    //   var _this = this
    //   this.loading = true
    //   this.$http.post('/api/salesadjustments/getPurchaseAdj?saleId='+row.sales_id+'&shp_id='+row.est_shop_id).then(function(response) {
    //     console.log(response)
    //       if(response.data.data === null){
    //         setTimeout(function(){ _this.loading = false}, 2000);
    //         alert('Sale with Id - ' + row.sales_id + ' is into Sale Adjustment, So delete the Sale Entry instead of Return')
    //       }
    //       else{
    //         _this.viewSale2(row)
    //       }
    //      }).catch(function(error){
    //       // _this.$router.push({ name: 'Edit Purchase', params: { 'purchaseId': row.purchase_id, 'shopId': row.est_shop_id }})
    //   })
    // },
  },
};
</script>
<style>
  .modal-title{
  color:black;
  font-weight:bold;
  }
</style>


// WEBPACK FOOTER //
// src/views/sales/sales.vue